import React from 'react';
import PropTypes from 'prop-types';

import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';
import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';

import SimpleInputEventEditor from 'app/shared/components/testing-suite/InputEventEditor';
import InputEventEditorWithSamples from 'app/shared/components/testing-suite/InputEventEditorWithSamples';

export default function GatedInputEventEditor(props) {
  const { sampleEventsAlphaEnabled } = useFeatureEnabled(FEATURE_FLAGS.sampleEventsAlpha);

  if (sampleEventsAlphaEnabled) {
    return <InputEventEditorWithSamples {...props} />;
  }

  return <SimpleInputEventEditor {...props} />;
}

GatedInputEventEditor.propTypes = {
  defaultValue: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  setHasValidInput: PropTypes.func.isRequired,
  trackingEventName: PropTypes.string.isRequired,
};
